/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Included_BadgeInputs */



/**
* | output |
* | --- |
* | "Included with Pro" |
*
* @param {Agent_Included_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const agent_included_badge = /** @type {((inputs?: Agent_Included_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Included_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclus avec Pro")
	if (locale === "de") return /** @type {LocalizedString} */ ("In Pro enthalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incluso con Pro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Входит в Pro")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluido con Pro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Pro 已包含")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Pro に含まれます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Pro में शामिल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incluído no Pro")
	return /** @type {LocalizedString} */ ("Included with Pro")
});